module.exports = __webpack_public_path__ + "static/media/restaurant-empty-icon.78d88ada.png";